export default __webpack_public_path__ + "static/media/otp.93d35e1b.svg";